import $ from 'jquery'
import { isMobileBreakpoint } from './helpers'

/*
 Youtube player
*/

window.player

window.onYouTubePlayerAPIReady = function () {
  window.player = new YT.Player('player', {
    width: '100%',
    videoId: 'gzJLKcOK1zI',
    playerVars: {
      controls: 0,
      showinfo: 0,
      rel: 0,
      modestbranding: 1,
    },
    events: {
      onStateChange: onPlayerStateChange,
    },
  })
}

function onPlayerStateChange(event) {
  if (event.data === 0) {
    closeVideoModal()
  }
}

/*
  Fade in after video
*/

const video = document.querySelector('.hero-video')

video.addEventListener('timeupdate', function () {
  if (!isNaN(this.duration)) {
    var percentComplete = this.currentTime / this.duration

    // Activate text and scroll at 45%
    if (percentComplete === 1) {
      video.classList.add('hide')
      document.querySelector('.hero-image').classList.add('active')
    } else if (percentComplete > 0.77) {
      document.body.classList.add('body--active')
    }
  }
})

/*
  Open/Close video modal
*/

$('.hero-scroll-video').on('click', function () {
  $('.video-modal').addClass('video-modal--active')
  window.player.playVideo()
})

$('.video-modal-close').on('click', function () {
  closeVideoModal()
})

export function closeVideoModal() {
  $('.video-modal').removeClass('video-modal--active')
  window.player.pauseVideo()
}

/*
  Parallax effect
*/

const vid = $('.hero-scroll-video')
const heroText = $('.hero-text')

$(window).on('scroll', function () {
  const pos = $(window).scrollTop()

  vid.css('margin-bottom', `${pos * 0.75}px`)
  heroText.css('margin-bottom', `${pos * 0.55}px`)
})

$(window).on('load', function () {
  const t1 = performance.now()
  console.log(`Site loaded in ${t1 - t0} milliseconds.`)
})

/*
  Hide after scroll
*/

$(window).on('scroll', function () {
  const pos = $(window).scrollTop()

  if (pos > 2000) {
    $('.hero-video, .hero-image').hide()
  } else {
    $('.hero-video, .hero-image').show()
  }
})
